import drivingSchoolReducer from './drivingSchoolReducer'
import metaDataReducer from './metaDataReducer'
import driverReducer from './driverReducer'
import authenticationReducer from './apiReducers/authenticationReducer'
import registerReducer from './apiReducers/registerReducer'
import { combineReducers } from 'redux'

const rootReducer = combineReducers({
  drivingSchool: drivingSchoolReducer,
  metaData: metaDataReducer,
  driver: driverReducer,
  authentication: authenticationReducer,
  register: registerReducer,
})

export default rootReducer
